import "@/App.css";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import { LanguageProvider } from '@/context/LanguageContext';
import HomePage from '@/pages/HomePage';
import TradePage from '@/pages/TradePage';
import { PrivacyPage, TermsPage, SmsTermsPage } from '@/pages/LegalPages';
import AdminLogin from '@/components/AdminLogin';
import AdminDashboard from '@/components/AdminDashboard';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Toaster position="top-right" toastOptions={{ style: { background: '#141414', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' } }} />
          <Routes>
            {/* English */}
            <Route path="/" element={<HomePage />} />
            <Route path="/roofing" element={<TradePage tradeKey="roofing" />} />
            <Route path="/impact-windows" element={<TradePage tradeKey="impact-windows" />} />
            <Route path="/hvac" element={<TradePage tradeKey="hvac" />} />
            <Route path="/remodeling" element={<TradePage tradeKey="remodeling" />} />
            <Route path="/electrical" element={<TradePage tradeKey="electrical" />} />

            {/* Spanish */}
            <Route path="/es" element={<HomePage />} />
            <Route path="/es/techos" element={<TradePage tradeKey="roofing" />} />
            <Route path="/es/ventanas-de-impacto" element={<TradePage tradeKey="impact-windows" />} />
            <Route path="/es/aire-acondicionado" element={<TradePage tradeKey="hvac" />} />
            <Route path="/es/remodelacion" element={<TradePage tradeKey="remodeling" />} />
            <Route path="/es/electrico" element={<TradePage tradeKey="electrical" />} />

            {/* Legal */}
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/sms-terms" element={<SmsTermsPage />} />
            <Route path="/es/privacidad" element={<PrivacyPage />} />
            <Route path="/es/terminos" element={<TermsPage />} />
            <Route path="/es/terminos-sms" element={<SmsTermsPage />} />

            {/* Admin */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
